import { render, staticRenderFns } from "./PhotoContainer.vue?vue&type=template&id=a812ac4c&scoped=true&"
import script from "./PhotoContainer.vue?vue&type=script&lang=js&"
export * from "./PhotoContainer.vue?vue&type=script&lang=js&"
import style0 from "./PhotoContainer.vue?vue&type=style&index=0&id=a812ac4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a812ac4c",
  null
  
)

export default component.exports